import Vue from 'vue';
import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import filterQueryGenerator from '../../helper/filterQueryGenerator';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  pendingCount: 0,
  allCount: 0,
  botCount: 0,
  filteredCount: 0
};

export const getters = {
  getStats: $state => $state,
};

export const actions = {
  get: async ({ commit, rootState }, params) => {
    try {
      // Check if we have applied filters in the conversations module
      const appliedFilters = rootState.conversations?.appliedFilters || [];
      const hasAppliedFilters = appliedFilters.length > 0;
      
      let response;
      if (hasAppliedFilters) {
        // When filters are applied, we need to use the filter endpoint to get accurate stats
        console.log('🔍 Using filter endpoint for stats due to applied filters');
        
        // Use filterQueryGenerator to properly process the applied filters
        const processedFilters = filterQueryGenerator(appliedFilters);
        const filterQuery = {
          queryData: processedFilters,
          page: 1 // We only need the meta, not the actual conversations
        };
        
        response = await ConversationApi.filter(filterQuery);
      } else {
        // No filters applied, use the regular meta endpoint
        response = await ConversationApi.meta(params);
      }
      
      const {
        data: { meta },
      } = response;
      
      commit(types.SET_CONV_TAB_META, meta);
    } catch (error) {
      // Ignore error
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      pending_count: pendingCount,
      all_count: allCount,
      bot_count: botCount,
      filtered_count: filteredCount
    } = {}
  ) {
    Vue.set($state, 'mineCount', mineCount);
    Vue.set($state, 'allCount', allCount);
    Vue.set($state, 'unAssignedCount', unAssignedCount);
    Vue.set($state, 'pendingCount', pendingCount);
    Vue.set($state, 'botCount', botCount);
    Vue.set($state, 'filteredCount', filteredCount);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
